import moment from "moment";
import { Vue } from "vue-class-component";
import { camelCase } from "lodash";
import { useStore } from "../store";
import HomepageService from "../service/HomepageService";


// You can declare mixins as the same style as components.
export default class UtilityOptions extends Vue {

    protected store = useStore();

    formatDate(value) {
        let d = "";
        if (value) {
            d = moment(value).format("DD-MM-YYYY");
        }
        return d;
    }
    
    formatMonthDate(value) {
        let d = "";
        if (value) {
            d = moment(value).format("MMM-YY");
        }
        return d;
    }

    get userPermission() {
        const p = JSON.parse(this.store.getters.gerUserPermissions);
        return p;
    }

    getDayName(date) {
        let d = "";

        if (date != "") {
            d = moment(date).format("ddd");
        }

        return d;
    }

    formatTime(value) {
        let d = "";
        if (value) {
            d = moment(value, "HH:mm").format("hh:mm A");
        }
        return d;
    }

    formatAmount(value) {
        value = Number(value);
        return value.toFixed(2);
    }

    camelizeKeys = obj => {
        if (Array.isArray(obj)) {
            return obj.map(v => this.camelizeKeys(v));
        } else if (obj !== null && obj.constructor === Object) {
            return Object.keys(obj).reduce(
                (result, key) => ({
                    ...result,
                    [camelCase(key)]: this.camelizeKeys(obj[key])
                }),
                {}
            );
        }
        return obj;
    };

    can(permission) {
        const pL = this.userPermission;
        const f = pL.filter(e => e.name == permission);

        let res = false;

        if (f.length > 0) {
            res = true;
        }

        return res;
    }

    convertToFull(t) {
        let n = "";

        if (t == "REF") {
            n = "Receive Funds";
        } else if (t == "DPT") {
            n = "Bank Deposit";
        } else if (t == "EXP") {
            n = "Bank Expense";
        } else if (t == "FTR") {
            n = "Funds Transfer";
        } else if (t == "CHQ") {
            n = "Cheque";
        } else if (t == "INE") {
            n = "Sales Invoice";
        } else if (t == "RFD") {
            n = "Sales Refund";
        } else if (t == "TRN") {
            n = "Stock Transfer";
        } else if (t == "PUR") {
            n = "Stock Purchase";
        } else if (t == "RPU") {
            n = "Purchase Stock Return";
        } else if (t == "SLS") {
            n = "Sales Receipt";
        } else if (t == "INV") {
            n = "Invoice Receipt";
        } else if (t == "RFR") {
            n = "Refund Receipt";
        } else if (t == "CRV") {
            n = "Credit Voucher";
        } else if (t == "DBV") {
            n = "Debit Voucher";
        } else if (t == "JRV") {
            n = "Journal Voucher";
        } else if (t == "EXV") {
            n = "Expense Voucher";
        } else if (t == "OPB") {
            n = "User Opening balance";
        }

        return n;
    }

    formatDateTime(date) {
        return moment(date).format("DD-MM-YYYY hh:mm A");
    }

    printReceiptUtil() {
        window.print();
    }

    convertNineDNicToTwelve(nic){

        // Check if the input is a valid 9-digit string
        if (nic.length !== 10) {
            return nic;
        } 

        // Add '19' to the start of the NIC
        let modifiedNIC = '19' + nic;

        // Add '0' to the 6th digit (index 5)
        modifiedNIC = modifiedNIC.slice(0, 5) + '0' + modifiedNIC.slice(5);

        // Remove the last character
        modifiedNIC = modifiedNIC.slice(0, -1);

        return modifiedNIC;
    }

    validateNic(nic){
        nic = nic.trim();
        const today = new Date();
        const currentYear = today.getFullYear();

        const modifiedNic = this.convertNineDNicToTwelve(nic);
        // year validation
        if(modifiedNic.slice(0, 4) > currentYear){
            return false;
        }

        // 12 digit formatted NIC validation
        const rex = /^(19[0-9]{2}|20[0-9]{2})((00[1-9]|0[1-9][0-9]|[12][0-9]{2}|365)|(500|[5-8][0-9]{2}|865))\d{5}$/;
        const validTwelveNic = rex.test(modifiedNic);

        if(nic.length == 10){
            // 10 digit vaidation
            const validateTen = /^([0-9]{9})([V,v,X,x]{1})$/;
            const validNicWithLastChar = validateTen.test(nic);

            return (validNicWithLastChar && validTwelveNic);
        }
        return validTwelveNic;
    }

    formatPhoneNumber(phone){
        // get and trim phone number
        // possible Phone number types 
        // 712xxxxxx : 9
        // 0112xxxxxx : 10
        // 0717xxxxxx : 10
        // 9471xxxxxxx : 11
        // +94717xxxxxx : 12
        var modifiedPhone = phone.trim();
        if(modifiedPhone.length == 9){
            // ok and add 94
            modifiedPhone = '94' + modifiedPhone;
        } else if(modifiedPhone.length == 10){
            // Get last 9 digits and add 94
            modifiedPhone = '94' + modifiedPhone.slice(-9);
        } else if(modifiedPhone.length == 11){
            // should be ok
        } else if(modifiedPhone.length == 12){
            // remove first char + and will fix this issue scenario Numeric Validation
            modifiedPhone = modifiedPhone.slice(-11);
        } else {
            modifiedPhone = '';
        }

        return modifiedPhone;
    }

    validateMobileNumber(phone){
        // get and trim phone number
        // possible Phone number types 
        // 712xxxxxx : 9
        // 0112xxxxxx : 10 Should ignore Land Numbers
        // 0717xxxxxx : 10
        // 9471xxxxxxx : 11
        // +94717xxxxxx : 12

        var modifiedPhone = this.formatPhoneNumber(phone);

        if(modifiedPhone == ''){
            return false;
        } else if (modifiedPhone.slice(2,3) == 7){
            return true;
        }
    }

    test(){
        alert('Test');
    }
}
